
import PatientScheduleService from '../services/patientSchedule.service';

const patientSchedules = {
  namespaced: true,

  state: {
  },

  mutations: {
  },

  actions: {
    get(_, { patientId, scheduleId }) {
      return PatientScheduleService.get(patientId, scheduleId);
    },
    getNexts(_, patientId) {
      return PatientScheduleService.getNexts(patientId);
    },
    getStatistics(_, patientId) {
      return PatientScheduleService.getStatistics(patientId);
    },
    getByStatus(_, { patientId, status }) {
      return PatientScheduleService.getByStatus(patientId, status);
    },
    saveReminder(_, { patientId, parameters }) {
      return PatientScheduleService.saveReminder(patientId, parameters);
    },
    cancel(_, { patientId, scheduleId }) {
      return PatientScheduleService.cancel(patientId, scheduleId);
    },
  },

  getters: {
  },
};

export default patientSchedules;
